import { useContext } from 'react'
import { GetHealthCareServiceByIdResponseIds } from '@toktokdoctech/tokapi-client'
import { CurrentHcsContext } from '../components/feature/hcs/CurrentHcsProvider/CurrentHcsContext'

const useCurrentHcs = (): GetHealthCareServiceByIdResponseIds => {
    const hcsContext = useContext(CurrentHcsContext)

    if (!hcsContext?.currentHcs) {
        throw new Error(`[useCurrentHcs] Expected current Hcs not to be null!`)
    }

    return hcsContext.currentHcs
}

export default useCurrentHcs
